import { Breadcrumb, Client, Primitive, User } from "@sentry/core"
import { ExclusiveEventHintOrCaptureContext } from "@sentry/core/build/types/utils/prepareEvent"
import * as Sentry from "@sentry/react"
import { BrowserOptions, init } from "@sentry/react"

import { env, getChromiumVersion, Platform, platform } from "./constants"

const isCompatible = () => {
  // prevent dev reports
  if (platform === Platform.Web) return false
  // https://docs.sentry.io/platforms/javascript/troubleshooting/supported-browsers/
  const chromiumVersion = getChromiumVersion()
  return typeof chromiumVersion === "number" && chromiumVersion >= 71
}

export const initSentry = (
  browserOptions: BrowserOptions,
): Client | undefined => {
  if (!isCompatible()) return
  return init({
    ...browserOptions,
    environment: env.env === "staging" ? "Staging" : "Production",
  })
}

export const setSentryTag = (key: string, value: Primitive) => {
  if (!isCompatible()) return
  Sentry.setTag(key, value)
}

export const setSentryUser = (user: User) => {
  if (!isCompatible()) return
  Sentry.setUser(user)
}

export const captureSentryException = (
  exception: unknown,
  hint?: ExclusiveEventHintOrCaptureContext,
) => {
  if (!isCompatible()) return
  Sentry.captureException(exception, hint)
}

export const addBreadCrumb = (item: Breadcrumb) => {
  if (!isCompatible()) return
  Sentry.addBreadcrumb(item)
}
